import { useParams } from 'react-router-dom';
import useGetOrganizationService from '@/hooks/admin/organizationServices/useGetOrganizationService';
import getLiveInstanceSectionPath from '@/pages/admin/organizations/OrganizationDetail/ServicesTab/LiveServicesTab/helpers/getLiveInstanceSectionPath';
import EntityBreadcrumb from '../EntityBreadcrumb';
import type { LiveOrganizationServiceInstanceCrumbProps } from './types';

const LiveOrganizationServiceInstanceCrumb = ({
    param,
    isCurrentPage,
}: LiveOrganizationServiceInstanceCrumbProps) => {
    const params = useParams();
    const instanceId = params[param] || '';
    const organizationId = params.organizationId || '';
    const { instance, isLoadingInstance } = useGetOrganizationService({
        organizationId,
        instanceId,
    });

    return (
        <EntityBreadcrumb
            label={instance ? instance.name : 'Service'}
            entityId={instanceId}
            entityType="Service instance"
            href={getLiveInstanceSectionPath({
                organizationId,
                instanceId,
                section: 'requirements',
            })}
            isCurrentPage={isCurrentPage}
            isLoading={isLoadingInstance && instance === null}
        />
    );
};

export default LiveOrganizationServiceInstanceCrumb;
